import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// import {SCAPIN_BLACK, SCAPIN_BLUE, SCAPIN_GREEN, SCAPIN_ORANGE, SCAPIN_RED} from '../models/colors';

Vue.use(Vuetify);
export const SCAPIN_GREEN = '#74cebc';
export const SCAPIN_BLUE = '#83c0e6';
export const SCAPIN_ORANGE = '#ef9b6c';
export const SCAPIN_RED = '#f26b76';
export const SCAPIN_BLACK = '#062b33';


export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    themes: {
      light: {
        primary: SCAPIN_BLUE,
        secondary: SCAPIN_BLACK,
        accent: SCAPIN_BLUE,
        error: SCAPIN_RED,
        info: SCAPIN_BLUE,
        success: SCAPIN_GREEN,
        warning: SCAPIN_ORANGE
      }
    }
  }
});
